import { Serializable } from '@/models/core/serializable';

export class EvalSettingTitleLang implements Serializable<EvalSettingTitleLang> {
  langCode: string;
  title: string;
  valid: boolean = true;

  deserialize(input: any): EvalSettingTitleLang {
    this.langCode = input.langCode;
    this.title = input.title
    return this;
  }
}
